var _style, _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseQuit = function SvgCloseQuit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".close_quit_svg__st0{fill:none;stroke:#231f20;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "close_quit_svg__Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "close_quit_svg__st0",
    d: "m14.8 15 18.1 18M32.9 15 14.8 33"
  }))))));
};
export default SvgCloseQuit;